import React from 'react'

import { ModalStore } from 'Store'

import Header from 'Components/Header'
import { Grid } from 'lese'
import Card from 'Components/Card'
import ModalCard from '../components/ModalCard'

import {
  faGripVertical,
  faMobile,
  faBuilding,
  faUser
} from '@fortawesome/free-solid-svg-icons'

export default () => {
  const showModal = ({ isCluster, isOffice, isPatient }) =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <ModalCard
          title="App"
          baseUrl="/device/report"
          isOffice={isOffice}
          isPatient={isPatient}
          isCluster={isCluster}
          isDevice={true}
          title={
            isCluster
              ? 'Cluster'
              : isOffice
              ? isPatient
                ? 'Patient'
                : 'Office'
              : 'App'
          }
          icon={
            isCluster
              ? faGripVertical
              : isOffice
              ? isPatient
                ? faUser
                : faBuilding
              : faMobile
          }
        />
      ]
    }))

  return (
    <>
      <Header>Device Report Tools</Header>
      <Grid columns="1fr 1fr 1fr" rows="1fr 1fr" gap="16px">
        <Card
          title="Cluster"
          onClick={() => showModal({ isCluster: true })}
          icon={faGripVertical}
        ></Card>
        <Card title="App" onClick={showModal} icon={faMobile}></Card>
        <Card
          title="Office"
          icon={faBuilding}
          onClick={() => showModal({ isOffice: true })}
        ></Card>
        <Card
          title="Patient"
          icon={faUser}
          onClick={() => showModal({ isOffice: true, isPatient: true })}
        ></Card>
      </Grid>
    </>
  )
}
